import { createAction } from '@reduxjs/toolkit'

export const transactions = createAction<{transactions: any}>('transaction/transactions');

